/*

FILE: modal.js
DESCRIPTION: Modal functionality
AUTHOR(S): R.J. LaCount

*/

import { elements } from './elements';

const openBioModal = (e) => {
	const parent = e.target.closest('.bio-wrap');
	const bioContent = parent.querySelector('.bio-content-src').cloneNode(true);

	elements.bioModalContent.innerHTML = '';
	elements.bioModalContent.scrollTop = 0;
	elements.bioModalContent.appendChild(bioContent);

	elements.bioModal.classList.add('show');
	elements.modalOverlay.classList.add('show');
	document.body.classList.add('overflow-hidden');

	elements.modalClose.forEach(el => {
		el.classList.remove('hidden');
	});
}

const closeBioModal = () => {
	elements.bioModal.classList.remove('show');
	elements.modalOverlay.classList.remove('show');
	document.body.classList.remove('overflow-hidden');

	elements.modalClose.forEach(el => {
		el.classList.add('hidden');
	});
}

const initBioModals	= () => {
}

export { openBioModal, closeBioModal, initBioModals };
